import {createFileRoute} from '@tanstack/react-router'
import {WalletSwap} from "@/components/wallet/WalletSwap/WalletSwap.tsx"

export const Route = createFileRoute('/_mainLayout/wallet/swap/')({
  component: RouteComponent,
})

function RouteComponent() {
  return <WalletSwap/>
}
